import { Layer, LayerGroup } from "../types";
import { ConstraintsCategory } from "../../Constraints/types";
import { TrafficLayerType } from "../layer_types/TrafficLayerType";
import Feature from "src/js/stores/user/Feature";
import { AdoptedRoadsLayerType } from "../layer_types/AdoptedRoadsLayerType";

export const ADOPTED_ROADS: Layer = {
  id: "ADOPTED_ROADS",
  layerType: AdoptedRoadsLayerType,
  title: "Adopted roads",
  requiredFeatureAccess: [Feature.adoptedRoadsLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.TRAFFIC,
  icon: "lt-layer-adopted-roads",
  description: "Adoption status for the road network",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 15,
    minConsiderationZoom: 15,
  },
  layerConfig: {
    autoHighlight: true,
    minZoom: 15,
    rootCategory: ConstraintsCategory.ADOPTED_ROADS,
    categorySchema: [
      { key: "highway_maintenance_public" },
      { key: "highway_maintenance_prospective" },
      { key: "highway_maintenance_nonpublic" },
      { key: "highway_maintenance_unclassified" },
    ],
  },
};

export const TRAFFIC_COUNTS: Layer = {
  id: "TRAFFIC_COUNTS",
  layerType: TrafficLayerType,
  title: "Road & Traffic counts",
  requiredFeatureAccess: [Feature.roadsAndTrafficLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.TRAFFIC,
  icon: "lt-layer-road-traffic-counts",
  description: "Road and traffic volumes by vehicle",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.ROADS_AND_TRAFFIC,
    categorySchema: [
      { key: "open_roads_m" },
      { key: "traffic_counts_m" },
      { key: "open_roads_a" },
      { key: "traffic_counts_a" },
      { key: "open_roads_b" },
      { key: "traffic_counts_b" },
      { key: "open_roads_c" },
      { key: "open_roads_u" },
      { key: "traffic_counts_c_u" },
    ],
    // displayBy: {
    //   showDropdown: true,
    //   attributeOptions: [
    //     { attribute: "roads_and_traffic", label: "Road & traffic counts" },
    //     { attribute: "open_roads", label: "Roads" },
    //     { attribute: "traffic_counts", label: "Traffic counts" },
    //   ],
    // },
    // attributeFilters: [
    //   {
    //     attribute: "road_category",
    //     options: [
    //       { value: "TA", display_name: "A Roads" },
    //       { value: "PA", display_name: "B Roads" },
    //       { value: "PA", display_name: "Motorways" },
    //       { value: "PA", display_name: "Unclassified Roads" },
    //     ],
    //   },
    // ],
  },
};
